import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { Header, HeaderTitle } from 'components/Header'

import classes from 'components/Form/Form.module.scss'

import {
  RedshiftDefaultDatabase,
  RedshiftDefaultSchema
} from 'modules/FormsContent/Sources/Redshift/Defaults/Fields'
import { WarehouseLabels } from 'types'

interface RedshiftDefaultsProps {
  onCancel?: () => void
  onPrevious?: () => void
  showCancel?: boolean
  showPrevious?: boolean
  modalContent?: string
  isEditEnvironment?: boolean
}

export const RedshiftDefaults: FunctionComponent<RedshiftDefaultsProps> = ({
  onCancel,
  onPrevious,
  showCancel = false,
  showPrevious = false,
  modalContent,
  isEditEnvironment = false
}) => {
  const { t } = useTranslation()

  return (
    <>
      <Header
        onCancel={onCancel}
        showCancel={showCancel}
        onPrevious={onPrevious}
        showPrevious={showPrevious}
        modalContent={modalContent}
      >
        <HeaderTitle data-testid="redshift-default-title">
          {t(
            isEditEnvironment
              ? 'formContent.editEnvironmentDefaults.title'
              : 'formContent.defaults.title',
            {
              projectType: WarehouseLabels.Redshift
            }
          )}
        </HeaderTitle>
      </Header>
      <div
        className={classNames(
          classes.Form__InnerWrap,
          classes['Form__InnerWrap--space-top']
        )}
      >
        <RedshiftDefaultDatabase />
        <RedshiftDefaultSchema />
      </div>
    </>
  )
}
